import React from 'react'

import ReactDOM from 'react-dom/client'
import {
    RouterProvider,
    createBrowserRouter,
    createRoutesFromChildren,
    matchRoutes,
    useLocation,
    useNavigationType
} from 'react-router'

import * as Sentry from '@sentry/react'

import '@/globals.css'
import '@/index.css'

import AppContextProvider from '@/components/base/appcontext'
import AppTonConnectProvider from '@/components/tonconnect-ui/AppTonConnectProvider'
import UserContextProvider from '@/hooks/user'
import { buildAppRoutes } from '@/appRoutes'

import { ThemeProvider } from '@/hooks/theme'
import { tgUserLoader } from '@/components/tg/user'

Sentry.init({
    dsn: 'https://cb30af4eb312a31cd715539cfa293eef@o4508689192124416.ingest.us.sentry.io/4508689193762816',
    integrations: [
        Sentry.reactRouterV7BrowserTracingIntegration({
            useEffect: React.useEffect,
            useLocation,
            useNavigationType,
            createRoutesFromChildren,
            matchRoutes
        }),
        Sentry.replayIntegration()
    ],
    replaysSessionSampleRate: 0.01,
    replaysOnErrorSampleRate: 1.0,
    tracesSampleRate: 1.0
})

const sentryCreateBrowserRouter =
    Sentry.wrapCreateBrowserRouterV7(createBrowserRouter)

function bootstrap(): Promise<
    Awaited<ReturnType<typeof tgUserLoader>> | undefined
> {
    return tgUserLoader().catch((error) => {
        console.error('Bootstrap error:', error)
        Sentry.captureException(error)
        return undefined
    })
}

bootstrap().then((initialUser) => {
    const router = sentryCreateBrowserRouter(buildAppRoutes())

    ReactDOM.createRoot(document.getElementById('root')!).render(
        <ThemeProvider>
            <UserContextProvider initialUser={initialUser}>
                <AppContextProvider>
                    <AppTonConnectProvider>
                        <React.StrictMode>
                            <RouterProvider router={router} />
                        </React.StrictMode>
                    </AppTonConnectProvider>
                </AppContextProvider>
            </UserContextProvider>
        </ThemeProvider>
    )
})
